import React from 'react';
import PropTypes from 'prop-types';
import CrumbsType from '../../types/crumb';

import './bread-crumbs.css';

export const handleCrumbsClick = (e, onChangeLocation, path) =>
{
  e.preventDefault();
  e.nativeEvent.stopImmediatePropagation();
  onChangeLocation(path);
};

const BreadCrumbs = ({ location, onChangeLocation }) =>
{
  const currentLocation = [...location];
  const lastCrumb = currentLocation.pop();
  const crumbsElements = [];

  currentLocation.forEach(crumb =>
  {
    const { name, path } = crumb;
    crumbsElements.push(
      <div
        className="resource-dialog__bread-crumb"
        key={`crumb-${path}`}
      >
        <a
          href={path}
          className="resource-dialog__bread-crumb-link resource-dialog__link"
          onClick={e => handleCrumbsClick(e, onChangeLocation, path)}
          data-test-id="idIRD_BreadCrumbsLink"
        >{name}</a>
      </div>
    );
    crumbsElements.push(
      <div
        className="resource-dialog__bread-crumb-divider"
        key={`divider-crumb-${path}`}
      />
    );
  });

  if (lastCrumb)
  {
    crumbsElements.push(
      <div
        className="resource-dialog__bread-crumb resource-dialog__bread-crumb_active"
        key="last-crumb"
        data-test-id="idIRD_BreadCrumbsCurrentLocation"
      >
        {lastCrumb.name}
      </div>
    );
  }

  return (
    <div className="resource-dialog__bread-crumbs">
      {crumbsElements}
    </div>
  );
};

BreadCrumbs.propTypes = {
  location: PropTypes.arrayOf(CrumbsType).isRequired
};

export default BreadCrumbs;